<template>
  <div>
    <div
      v-if="question_type === SurveyQuestion.NPS"
      class="flex flex-row items-center justify-between gap-2 mb-1"
    >
      <div>
        {{ $t('survey.labels.notAtAllLikely') }}
      </div>

      <div>
        {{ $t('survey.labels.extremelyLikely') }}
      </div>
    </div>
    <div
      class="flex flex-row items-center justify-center gap-2 flex-wrap"
      data-test="survey-rating"
    >
      <PButton
        v-for="(score, index) in scores"
        :key="score.value"
        data-test="button-survey-rating"
        style="height: 40px; width: 100%"
        :variant="score.active ? '' : 'outlined'"
        @click="!disabled && selectScore(score.value)"
        @mouseleave="!disabled && mouseLeave()"
        @mouseover="!disabled && mouseOver(score.value)"
      >
        <div>
          {{ score.value }}
        </div>
      </PButton>
    </div>
  </div>
</template>

<script>
import { SurveyQuestion } from '@/app/data/model_constants';

const SCORES_DEFAULT = [
  { active: false, value: 0 },
  { active: false, value: 1 },
  { active: false, value: 2 },
  { active: false, value: 3 },
  { active: false, value: 4 },
  { active: false, value: 5 },
  { active: false, value: 6 },
  { active: false, value: 7 },
  { active: false, value: 8 },
  { active: false, value: 9 },
  { active: false, value: 10 },
];

export default {
  name: 'Rating',
  props: {
    disabled: { type: Boolean, default: false },
    default_value: { type: Number, default: null },
    question_type: { type: String, default: null },
  },

  data() {
    const scores = _.cloneDeep(SCORES_DEFAULT);

    if (typeof this.default_value === 'number') {
      scores.forEach((score, index) => {
        scores[index].active = score.value <= this.default_value;
      });
    }

    return {
      scores,
      selected: false,
      SurveyQuestion,
    };
  },

  watch: {
    default_value() {
      this.scores = _.cloneDeep(SCORES_DEFAULT);
      this.configureScore(this.default_value);
      this.selected = this.default_value >= 0 && this.default_value <= 10;
    },
  },

  methods: {
    mouseOver(scoreValue) {
      if (this.selected) return;
      this.configureScore(scoreValue);
    },

    mouseLeave() {
      if (this.selected) return;
      this.scores.forEach((score, index) => {
        this.scores[index].active = false;
      });
    },

    selectScore(scoreValue) {
      this.configureScore(scoreValue);
      this.selected = true;
      this.$emit('scoreSelected', scoreValue);
    },

    configureScore(scoreValue) {
      if (_.isNil(scoreValue)) return;

      this.scores.forEach((score, index) => {
        this.scores[index].active = score.value <= scoreValue;
      });
    },
  },
};
</script>
